import { AfterViewInit, Directive } from '@angular/core';

import { GasTableComponent } from './gas-table/gas-table.component';

/**
 * @description - директива, которая делает ячейки таблицы адаптивными. Размер ячейки будет рассчитываться исходя из максимального
 * относительно ячейки шапки и ячейки тела
 *
 * @example - <gas-table gasTableAutoColumns></gas-table>
 */
@Directive({
  selector: '[gasTableAutoColumns]',
})
export class GasTableAutoColumnsDirective implements AfterViewInit {

  public thElements: HTMLElement[] = [];

  constructor(
    private gasTable: GasTableComponent,
  ) {
  }

  public ngAfterViewInit(): void {
    this.gasTable.simpleTableComponent.autoColumns = true;
  }

}
